import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getRoleList as _getRoleList } from '@/api/sys.user';
export default {
  props: {
    isShowAddBuyerDialog: {
      type: Boolean,
      default: false
    }
  },
  mounted: function mounted() {
    this.getRoleList();
  },
  data: function data() {
    return {
      addForm: {
        USER_NAME: null,
        ROLE_ID: null,
        NICK_NAME: null,
        MOBILE: null,
        ENABLED: null,
        REMARK: null,
        Email: null
      },
      addFormRules: {
        USER_NAME: [{
          required: true,
          message: '请输入登录账户',
          trigger: 'blur'
        }],
        NICK_NAME: [{
          required: true,
          message: '请输入用户名称',
          trigger: 'blur'
        }],
        ROLE_ID: [{
          required: true,
          message: '请选择所属角色',
          trigger: ['blur', 'change']
        }],
        Email: [{
          required: true,
          message: '请输入邮箱地址',
          trigger: 'blur'
        }]
      },
      loading: false,
      roleOptions: []
    };
  },
  methods: {
    // 获取角色列表
    getRoleList: function getRoleList() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                _context.next = 3;
                return _getRoleList();

              case 3:
                res = _context.sent;
                console.log('角色列表', res);

                if (res.code === 0) {
                  _this.loading = false;
                  _this.roleOptions = res.data.map(function (v) {
                    return {
                      value: v.Id,
                      label: v.Role_Name
                    };
                  });
                }

                _this.loading = false;

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleCancel: function handleCancel() {
      this.$refs.addForm.resetFields();
      this.$emit('closeAddBuyerDialog');
    },
    handleDelSubmit: function handleDelSubmit() {
      this.$refs.addForm.validate(function (bool) {
        console.log(bool);
      });
    }
  }
};